export default "__VITE_ASSET__753fa78c__"